import { normalizePlate } from './plates';

const BASE_URL = process.env.REACT_APP_API_BASE_URL || '/api';

export async function fetchVehicle(plate) {
  const normalizedPlate = normalizePlate(plate);

  const response = await fetch(`${BASE_URL}/${normalizedPlate}`);

  if (!response.ok) {
    if (response.status === 404) {
      throw new Error(`No vehicle found for ${plate}.`);
    }
    throw new Error('Failed to fetch vehicle data. Please try again later.');
  }

  const data = await response.json();
  return data;
}
